export const h = {
  navMenu: ["ACCUEIL","PRÉ-INSCRIPTION", "HÉROS", "CARACTÉRISTIQUES"],

   
  }


// WEBPACK FOOTER //
// ./src/i18n/lan/fr.js